"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildQueryParams = (params) => {
    const query = Object.entries(params)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return query ? `?${query}` : '';
};
exports.default = buildQueryParams;
//# sourceMappingURL=buildQueryParams.js.map